import React from 'react';

import Routes from 'navigation/Routes';

const AppRoot = (): JSX.Element => {
    return (
        <Routes />
    );
};

export default AppRoot;
